
export default function TestimonialsSection() {
  const testimonials = [
    {
      position: 'Expert-Comptable Associé',
      company: 'Cabinet Comptable - Lyon',
      content: 'Depuis 3 ans, EMA traite 40% de notre portefeuille client. La qualité est irréprochable et nous avons pu nous concentrer sur le conseil à haute valeur ajoutée. Une collaboration que je recommande vivement.',
      rating: 5
    },
    {
      position: 'Directrice',
      company: 'Cabinet Expertise Conseil - Paris',
      content: 'La réactivité d\'EMA est exceptionnelle. Les déclarations sont toujours déposées dans les délais et la qualité du travail nous permet de gagner un temps précieux. Un partenaire de confiance.',
      rating: 5
    },
    {
      position: 'Expert-Comptable',
      company: 'Cabinet Comptable - Marseille',
      content: 'Grâce à EMA, nous avons réduit nos coûts de 55% tout en améliorant notre qualité de service. L\'équipe maîtrise parfaitement les spécificités françaises. Une collaboration exemplaire.',
      rating: 5
    }
  ];

  return (
    <section id="temoignages" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ils nous font confiance
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez les témoignages de cabinets comptables français qui ont choisi EMA 
            pour optimiser leur activité.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 relative">
              <div className="mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-user-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600">
                    {testimonial.position}
                  </p>
                  <p className="text-sm text-blue-900 font-medium">
                    {testimonial.company}
                  </p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>

              <p className="text-gray-700 italic">
                "{testimonial.content}"
              </p>

              <div className="absolute top-6 right-6">
                <i className="ri-double-quotes-r text-3xl text-blue-100"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-900 mb-2">10+</div>
              <div className="text-gray-600">Cabinets partenaires</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-900 mb-2">500+</div>
              <div className="text-gray-600">Dossiers traités/mois</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-900 mb-2">15</div>
              <div className="text-gray-600">Années d'expérience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-900 mb-2">98%</div>
              <div className="text-gray-600">Satisfaction client</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
